import axios from 'axios'
import appConfig from '@/config/app.js'

const service = axios.create({
  baseURL: process.env.NODE_ENV === 'dev' ? appConfig.HTTP_REQUEST_URL : '/api',
  timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 请求成功，返回业务数据
    if (res.result === true) {
      return res.data
    }
    // 业务逻辑错误
    console.error('业务错误：', res.code)
    return Promise.reject(new Error(res.code || '请求失败'))
  },
  error => {
    const msg = error.response
      ? `状态码: ${error.response.status}, 数据: ${JSON.stringify(error.response.data)}`
      : error.message
    console.error('请求错误：', msg)
    return Promise.reject(error)
  }
)

export default service
